import { useQuery } from "@tanstack/react-query";

import BannerApi from "api/BannerApi";
import { expireSession, useAuth } from "../../context/AuthContext";
import { getApiData, getApiErrorCode, type ApiError } from "../../types/api";

export interface BannerPayload {
  filedata?: string;
  mime?: string;
}

function handleBannerError(error: ApiError) {
  if (getApiErrorCode(error) === "NOT_LOGGED") {
    expireSession();
  }

  return null;
}

export function useBannerDocument() {
  const { customerData } = useAuth();
  const customerId = "id" in customerData ? customerData.id : null;

  const query = useQuery({
    queryKey: ["banner", "document", customerId],
    enabled: !!customerId,
    queryFn: () =>
      BannerApi.getBanner()
        .then((res) => getApiData(res, null) as BannerPayload | null)
        .catch((error: ApiError) => handleBannerError(error)),
  });

  return {
    ...query,
    banner: query.data || null,
    bannerLoaded: query.isSuccess,
  };
}
